/**
 * Depuración mínima del **número de bloque** (`getBlockNumber` / cabeza de cadena).
 *
 * Solo se escribe consola en **fallos** de `getBlockNumber`, con **throttle** global
 * para no inundar la consola si el RPC falla en cada poll.
 *
 * Activar sin rebuild: `localStorage.setItem('DEBUG_CHAIN_HEAD', '1'); location.reload()`
 * Por build: `VITE_DEBUG_CHAIN_HEAD=true`
 *
 * Guía: `docs/500-guias/logs-debug-y-flags.md`.
 */

import { localStorageDebugOn, viteEnvDebugTrue } from './debugActivation'

const LS_KEY = 'DEBUG_CHAIN_HEAD'
const LOG_PREFIX = '[CHAIN_HEAD]'
const ERROR_THROTTLE_MS = 60_000

let lastErrorLogAt = 0

export function isChainHeadDebugEnabled(): boolean {
  if (viteEnvDebugTrue(import.meta.env.VITE_DEBUG_CHAIN_HEAD)) return true
  if (typeof window === 'undefined') return false
  try {
    return localStorageDebugOn(window.localStorage?.getItem(LS_KEY))
  } catch {
    return false
  }
}

/** Errores de cabeza de cadena; como máximo una línea cada `ERROR_THROTTLE_MS` mientras el flag esté activo. */
export function chainHeadErrorDebug(tag: string, payload: Record<string, unknown>): void {
  if (!isChainHeadDebugEnabled()) return
  const now = Date.now()
  if (now - lastErrorLogAt < ERROR_THROTTLE_MS) return
  lastErrorLogAt = now
  // eslint-disable-next-line no-console
  console.warn(LOG_PREFIX, tag, payload)
}
